"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLatestRuleSetRevision = exports.getRuleSetRevisionFromJson = exports.isRuleSetV2 = exports.isRuleSetV1 = exports.getRuleSetRevisionSerializerFromVersion = exports.getRuleSetRevisionSerializer = void 0;
const revisionMap_1 = require("./revisionMap");
const v1_1 = require("./v1");
const v2_1 = require("./v2");
const getRuleSetRevisionSerializer = () => ({
    description: 'RuleSetRevision',
    fixedSize: null,
    maxSize: null,
    serialize: (revision) => (0, exports.getRuleSetRevisionSerializerFromVersion)(revision.libVersion).serialize(revision),
    deserialize: (buffer, offset = 0) => (0, exports.getRuleSetRevisionSerializerFromVersion)(buffer[offset]).deserialize(buffer, offset),
});
exports.getRuleSetRevisionSerializer = getRuleSetRevisionSerializer;
const getRuleSetRevisionSerializerFromVersion = (version) => (() => {
    switch (version) {
        case 1:
            return (0, v1_1.getRuleSetRevisionV1Serializer)();
        case 2:
            return (0, v2_1.getRuleSetRevisionV2Serializer)();
        default:
            throw new Error(`Unknown rule set revision version: ${version}`);
    }
})();
exports.getRuleSetRevisionSerializerFromVersion = getRuleSetRevisionSerializerFromVersion;
const isRuleSetV1 = (ruleSet) => ruleSet.libVersion === 1;
exports.isRuleSetV1 = isRuleSetV1;
const isRuleSetV2 = (ruleSet) => ruleSet.libVersion === 2;
exports.isRuleSetV2 = isRuleSetV2;
const getRuleSetRevisionFromJson = (json) => {
    const ruleSet = JSON.parse(json);
    if ((0, exports.isRuleSetV1)(ruleSet) || (0, exports.isRuleSetV2)(ruleSet))
        return ruleSet;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    throw new Error(`Unknown rule set version: ${ruleSet.libVersion}`);
};
exports.getRuleSetRevisionFromJson = getRuleSetRevisionFromJson;
const getLatestRuleSetRevision = (buffer) => {
    const revisionMap = (0, revisionMap_1.getRuleSetRevisionMapFromAccountData)(buffer);
    const latestRevisionStart = revisionMap.revisionLocations[revisionMap.revisionLocations.length - 1];
    const latestRevisionEnd = revisionMap.location;
    return (0, exports.getRuleSetRevisionSerializer)().deserialize(buffer.slice(latestRevisionStart, latestRevisionEnd))[0];
};
exports.getLatestRuleSetRevision = getLatestRuleSetRevision;
//# sourceMappingURL=revision.js.map